import Scriba from 'react-scriba';

export class DataOption {
    static _chargementFicheOption(idOperation, idLotCommercial) {
        let objet = { "idOperation": idOperation, "idLotCommercial": idLotCommercial }

        var url = "api/Fiche/FicheOption_OptionsDuLotCommercial";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementTitreOption(idOperation, idLotCommercial) {
        let objet = { "idOperation": idOperation, "idLotCommercial": idLotCommercial }

        var url = "api/Fiche/FicheOption_TitreOption";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementOption(idOption, idOperation, idLotCommercial, idContact, loginCompte) {
        let objet = {
            "idOption": idOption,
            "idOperation": idOperation,
            "idLotCommercial": idLotCommercial,
            "idContact": idContact,
            "loginCompte": loginCompte
        }

        var url = "api/MAJDonnees/EnregistrementOption";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionOption(idOption) {
        let objet = {
            "idOption": idOption
        }

        var url = "api/MAJDonnees/SuppressionOption";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheOption_Commercialisateurs(idOperation, idLotCommercial, idOption) {
        let objet = {
            "idOperation": idOperation,
            "idLotCommercial": idLotCommercial,
            "idOption": idOption
        }

        var url = "api/Fiche/FicheOption_Commercialisateurs";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

}